<template>
  <div class="certifikat ovoj" id="html">
     
    
     <div id="prvi-del">
      
        
        <div class="glava mali-ovoj">
            
            <div class="levi-logo">
               <img :src="certifikat.logoko">
            </div>
            <div class="glava certifikat">
                <h1>{{__("CERTIFIKAT")}}</h1>
                
            </div>
            <div class="desni-logo">
               <img :src="certifikat.logoak">
            </div>
        </div>
         
     <!--<div class="levi-stolpec">
      <div class="eko-napis">Ekološko kmetijstvo</div>
     </div>
   -->
     
      <!-- 1-4 -->
      <div class="celotna-sekcija">
      <div class="identifikacija sekcija">
        <div class="vrstica del-1">
       <div class="stevilka-certifikata">
        <div class="naslov kategorija">{{__("Številka dokumenta:")}}</div>
        <div class="stevilka-certifikata">{{ certifikat.stcertifikata }}</div>
        </div> 
       <div class="vrsta-certifikata">{{__(certifikat.vrstacertifikata)}}</div>
       </div>
       <div class="vrstica del-2">
        <!-- en ali več-->
         <div class="nosilec">
         
         <div class="naslov kategorija">{{__("Ime in naslov izvajalca dejavnosti:")}}</div>
          <div v-if="certifikat.subjekt_maticna_naziv" class="naziv-nosilca">{{certifikat.subjekt_maticna_naziv}}</div>
         <div v-if="certifikat.subjekt_maticna_naslov" class="naslov-nosilca">{{certifikat.subjekt_maticna_naslov}}</div>
         <div class="naziv-nosilca">{{certifikat.subjekt_naziv}}</div>
         <div class="naslov-nosilca">{{certifikat.subjekt_naslov}}</div>

        
       </div>  
         <div class="izvajalec">
        <div class="naslov">{{__("Ime in naslov izvajalca nadzora ter šifra:")}}</div> 
          <div class="naziv-izvajalca">{{certifikat.organ_ime}}</div>
          <div class="naslov-izvajalca">{{certifikat.organ_naslov}}</div>
          <div class="sifra-izvajalca">{{certifikat.organ_sifra}}</div>
        </div>

       </div>

      </div>

      <!-- 5 -->
      <div class="dejavnosti-izvajalca sekcija">

        <div class="naslov kategorija" v-if="certifikat.vrstacertifikata=='Izvajalec dejavnosti'">{{__("Dejavnosti izvajalca dejavnosti:")}}</div>
        <div class="naslov kategorija" v-if="certifikat.vrstacertifikata!='Izvajalec dejavnosti'">{{__("Dejavnosti skupine izvajalcev dejavnosti:")}}</div>
        <ul>
          <li v-for="(dejavnost,i) in certifikat.dejavnosti">
            {{__(dejavnost)}}
          </li>
         
        </ul>
      </div>
      <!-- 6 -->
       <div class="kategorije-proizvodov sekcija">
        <div class="naslov kategorija">
           {{__("Kategorije proizvodov iz člena 35(7) Uredbe (EU) 2018/848 Evropskega parlamenta in Sveta (1) ter metode pridelave:")}}
        </div>

        <kategorija :podatki="certifikat.rastline"
        :naslov="__('(a) nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom')"
        />
        <kategorija :podatki="certifikat.živali"
        :naslov="__('(b) živina in nepredelani proizvodi iz živine')"
        />
        <kategorija :podatki="certifikat.alge"
        :naslov="__('(c) alge in nepredelani proizvodi iz akvakulture')"
        />
        <kategorija :podatki="certifikat.proizvodi"
        :naslov="__('(d) predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano')"
        proizvod="true"
        />
        <kategorija :podatki="certifikat.krma"
        :naslov="__('(e) krma')" proizvod="true"
        />
        <kategorija :podatki="certifikat.vino"
        :naslov="__('(f) vino')" proizvod="true" 
        />
        <kategorija :podatki="certifikat.ostalo"
        :naslov="__('(g) ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije')"
        proizvod="true"
        />
      </div>
</div>
</div>
 <div id="drugi-del">
<div class="celotna-sekcija">
       <div v-if="proizvodi.filter(p=>(!(p.kategorija=='b'&&p.statuspridelkanaziv=='Iz preusmeritve')&&p.statuspridelkanaziv!='1. leto preusmeritve')).length>0" class="seznam seznam-proizvodov sekcija">
        <div class="naslov-kategorije">
            {{__("Seznam proizvodov")}}
        </div>
        <table cellspacing="0">
          <thead>
            <tr><td>{{__("Ime proizvoda in/ali oznaka kombinirane nomenklature (KN) iz Uredbe Sveta (EGS) št. 2658/87 za proizvode s področja uporabe Uredbe (EU) 2018/848")}}</td><td>{{__("Status")}}</td></tr>
          </thead>
          
          <template v-for="kategorija in certifikat.kategorije" v-if="proizvodi.filter(p=>(p.kategorija==kategorija.id&&!(kategorija.id=='b'&&p.statuspridelkanaziv=='Iz preusmeritve')&&p.statuspridelkanaziv!='1. leto preusmeritve')).length>0">
            <tbody>
          <tr>
            <td class="kategorija-naziv" colspan="2">{{__(kategorija.naziv)}}</td>
          </tr>
          <tr v-for="proizvod in proizvodi.filter(p=>(p.kategorija==kategorija.id&&!(kategorija.id=='b'&&p.statuspridelkanaziv=='Iz preusmeritve')&&p.statuspridelkanaziv!='1. leto preusmeritve'))">
            <td>{{__p(proizvod)}}</td>
            <td class="status no-wrap">{{__(proizvod.statuspridelkanaziv)}}</td>
          </tr>
          </tbody>
          </template>
          
        </table>
      </div>
       <div class=" seznam seznam-clanov sekcija">
        

       </div>
       <div v-if="certifikat.dejavnostizadrugo&&certifikat.dejavnostizadrugo.length>0" class="seznam seznam-dejavnosti sekcija">
         <div class="naslov-kategorije">
            {{__("Seznam dejavnosti")}}
        </div>
        <table>
          <thead>
            <tr><td colspan="2">{{__("Opis dejavnosti iz točke 5 dela I v skladu z Uredbo (EU) 2018/848")}}</td></tr>
          </thead>
          <tbody>
          <tr v-for="dejavnost in certifikat.dejavnostizadrugo">
            <td>{{__(dejavnost)}}</td>
            <td class="status">{{__("Izvajanje dejavnosti kot podizvajalec za drugega izvajalca dejavnosti, medtem ko podizvajalec ostaja odgovoren za dejavnost oziroma dejavnosti, ki se izvajajo")}}</td>
          </tr>
          </tbody>
          
        </table>
       </div>
        <div v-if="certifikat.informacije" class="seznam seznam-informacij sekcija">
         <div class="naslov-kategorije">
            {{__("Druge informacije")}}
        </div>
         <div class="vsebina-kategorije">
            {{certifikat.informacije}}
        </div>
       </div>

        <!-- 8 -->
        <div class="noga-info-group">
      <div v-if="certifikat.stariCertifikat"class="stari-certifikat sekcija">
        {{__("Ta dokument zamenjuje dokument s številko")}} {{certifikat.stariCertifikat}}.
      </div>

      <!-- 8  -->


      <div class="pravni-pouk sekcija">
        {{__("Ta dokument je bil izdan v skladu z Uredbo (EU) 2018/848 kot potrdilo, da izvajalec dejavnosti izpolnjuje zahteve iz navedene uredbe.")}}
      </div>

      <!-- 7 -->
       <div class="noga">
        <div class="vrstica del-2 sekcija">
         <div class="potrditev">
          <div class="naslov">{{__("Datum/kraj:")}}</div>
          <div class="datum-kraj">{{certifikat.datumizdaje}}, {{certifikat.organ_kraj}}</div>
          <div class="naslov">{{__("Direktor:")}}</div>
          <div class="certifikat-podpis">{{certifikat.organ_podpisnik}}</div>
         </div>  
         <div class="veljavnost">
           {{__("Certifikat je veljaven od")}} {{certifikat.datumizdaje}} {{__("do")}} {{certifikat.datumveljavnosti}}
         </div>
         </div>
      </div>
    </div>
      </div>
    </div>
</div>
</template>
<script>





import { mapState, mapActions } from 'vuex'
import CertifikatKategorija from './support/CertifikatKategorija.vue'


export default {
    props: ["certifikatid"],
    components:{"kategorija":CertifikatKategorija},
   
    
   data:function() {
        return {
            stDokumenta:"00001",
            vrstaCertifikata:"Izvajalec dejavnosti",
            subjekt:{naziv:"Bethanie Wiggins",naslov:"Baragov trg 12, 4000 Kranj"},
            organ:{ime:"Inštitut za kontrolo in certifikatcijo UM",naslov:"Pivola 8, 2311 Hoče",šifra:"SI-EKO-002"},
            pridelava:{rastline:{eko:["Koleraba","Trava"]},živali:{eko:["Apake","Konji, starejši od enega leta"],preusmeritev:["Fazani"]},alge:{}},
            predelava:{},
            krma:{},
            vino:{},
            ostalo:{},
            kategorije:[
            {id:"a",naziv:"rastline",sloNaziv:"Nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom",angNaziv:"Unprocessed plants and plant products, including seeds and other plant reproductive material"},
            {id:"b",naziv:"živali",sloNaziv:"Živina in nepredelani proizvodi iz živine",angNaziv:"Livestock and unprocessed livestock products"},
            {id:"c",naziv:"alge",sloNaziv:"Alge in nepredelani proizvodi iz akvakulture",angNaziv:"Algae and unprocessed aquaculture products"},
            {id:"d",naziv:"proizvodi",sloNaziv:"Predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano",angNaziv:"Processed agricultural products, including aquaculture products, for use as food"},
            {id:"e",naziv:"krma",sloNaziv:"Krma",angNaziv:"Feed"},
            {id:"f",naziv:"vino",sloNaziv:"Vino",angNaziv:"Wine"},
            {id:"g",naziv:"ostalo",sloNaziv:"Ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije",angNaziv:"Other products listed in Annex I to Regulation (EU) 2018/848 or not covered by the previous categories"}
            ]
           // certifikat:{}

        }
    },
    computed:{
      ...mapState({certifikat(state) {
      
          return state.certifikat.certifikat;
        }}), 
    jezik:{
       get() {
        var l={};
        l["lang-"+this.$route.query.lang]=true;
        return l;
       }
    },

     proizvodi:
        {
           get() {
            if(!this.certifikat.vsiproizvodi)
              return [];
            else
              return this.certifikat.vsiproizvodi.filter(i=>i.statuspridelkanaziv!='Neekološki').sort(
                (a,b)=>
                {
                  var x=a.vrstapridelkaid-b.vrstapridelkaid;
                  if(x)
                  return x;
                  else
                  {

                    return a.certifikat.localeCompare(b.certifikat);
                  }
                });
            
          },
        }
    
    },
     methods: {

        ...mapActions('certifikat', ['vrniPoId']),

        __p: function(value){
        
        if(!this.$route.query.lang)
            return value.certifikat


        else
            return value.info[this.$route.query.lang];


        },

       __: function(value){

        if(!this.$route.query.lang)
            return value


        let lang=this.$route.query.lang
        var translation={};

        translation["en"]={
                  "CERTIFIKAT":"CERTIFICATE",
                  "Številka dokumenta:":"Document number:",
                  "Izvajalec dejavnosti":"Operator",
                  "Ime in naslov izvajalca dejavnosti:":"Name and address of the operator:",
                  "Ime in naslov izvajalca nadzora ter šifra:":"Name and address of the control body and code number:",
                  "Dejavnosti izvajalca dejavnosti:":"Activity or activities of the operator:",
                  "Kategorije proizvodov iz člena 35(7) Uredbe (EU) 2018/848 Evropskega parlamenta in Sveta (1) ter metode pridelave:":"Category or categories of products as referred to in Article 35(7) of Regulation (EU) 2018/848 of the European Parliament and of the Council (1) and production methods:",
                  "(a) nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom":"(a) unprocessed plants and plant products, including seeds and other plant reproductive material",

                  "(b) živina in nepredelani proizvodi iz živine":"(b) livestock and unprocessed livestock products",
                  "(c) alge in nepredelani proizvodi iz akvakulture:":"(c) algae and unprocessed aquaculture products",
                  "(d) predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano":"(d) processed agricultural products, including aquaculture products, for use as food",
                  "(e) krma":"(e) feed",
                  "(f) vino":"(f) wine",
                  "(g) ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije":"(g) other products listed in Annex I to Regulation (EU) 2018/848 or not covered by the previous categories",
                  

                  "Nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom":"Unprocessed plants and plant products, including seeds and other plant reproductive material",
                  "Živina in nepredelani proizvodi iz živine":"Livestock and unprocessed livestock products",
                  "Alge in nepredelani proizvodi iz akvakulture:":"Algae and unprocessed aquaculture products",
                  "Predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano":"Processed agricultural products, including aquaculture products, for use as food",
                  "Krma":"Feed",
                  "Vino":"Wine",
                  "Ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije":"Other products listed in Annex I to Regulation (EU) 2018/848 or not covered by the previous categories",



                  "Ekološko kmetijstvo":"Organic production",
                  "Ekološki":"Organic",
                  "Iz preusmeritve":"In-conversion",
                  
                  "Pridelava":"Production",
                  "Priprava":"Preparation",
                  "Distribucija / Dajanje v promet":"Distribution/Placing on the market",
                  "Skladiščenje":"Storing",
                  "Uvoz":"Import",
                  "Izvoz":"Export",

                  "Seznam proizvodov":"Directory of products",
                  "Ime proizvoda in/ali oznaka kombinirane nomenklature (KN) iz Uredbe Sveta (EGS) št. 2658/87 za proizvode s področja uporabe Uredbe (EU) 2018/848":"Name of the product and/or Combined Nomenclature (CN) code as referred to in Council Regulation (EEC) No 2658/87 for products within the scope of Regulation (EU) 2018/848",
                  "Status":"Status",
                  "Seznam dejavnosti":"List of activities:",
                  "Opis dejavnosti iz točke 5 dela I v skladu z Uredbo (EU) 2018/848":"Description of the activity or activities as referred to in point 5 of part I in accordance with Regulation (EU) 2018/848",
                  "Izvajanje dejavnosti kot podizvajalec za drugega izvajalca dejavnosti, medtem ko podizvajalec ostaja odgovoren za dejavnost oziroma dejavnosti, ki se izvajajo":"Carrying out activity/activities as a subcontractor for another operator, while the subcontractor remains responsible for the activity or activities performed",
                  "Druge informacije":"Other information",
                  "Ta dokument zamenjuje dokument s številko":"This document replaces the document with the number",
                  "Ta dokument je bil izdan v skladu z Uredbo (EU) 2018/848 kot potrdilo, da izvajalec dejavnosti izpolnjuje zahteve iz navedene uredbe.":"This document has been issued in accordance with Regulation (EU) 2018/848 to certify that the operator or group of operators complies with that Regulation.",
                  "Datum/kraj:":"Date/place:",
                  "Direktor:":"Director:",
                  "Certifikat je veljaven od":"Certificate valid from",
                  "do":"to",
                  "telefon":"telephone"

            };


            translation["de"]={
                  "CERTIFIKAT":"ZERTIFIKAT",
                  "Številka dokumenta:":"Nummer des Zertifikats:",
                  "Izvajalec dejavnosti":"Unternehmer",
                  "Ime in naslov izvajalca dejavnosti:":"Name und Anschrift des Unternehmers:",
                  "Ime in naslov izvajalca nadzora ter šifra:":"Name und Anschrift der Kontrollbehörde und die Codenummer:",
                  "Dejavnosti izvajalca dejavnosti:":"Tätigkeit(en) des Unternehmers:",
                  "Kategorije proizvodov iz člena 35(7) Uredbe (EU) 2018/848 Evropskega parlamenta in Sveta (1) ter metode pridelave:":"Erzeugniskategorie(n) gemäß Artikel 35 Absatz 7 der Verordnung (EU) 2018/848 des Europäischen Parlaments und des Rates und Produktionsverfahren:",
                  "(a) nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom":"(a) unprocessed plants and plant products, including seeds and other plant reproductive material",

                  "(b) živina in nepredelani proizvodi iz živine":"(b) livestock and unprocessed livestock products",
                  "(c) alge in nepredelani proizvodi iz akvakulture:":"(c) algae and unprocessed aquaculture products",
                  "(d) predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano":"(d) processed agricultural products, including aquaculture products, for use as food",
                  "(e) krma":"(e) feed",
                  "(f) vino":"(f) wine",
                  "(g) ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije":"(g) other products listed in Annex I to Regulation (EU) 2018/848 or not covered by the previous categories",
                  

                  "Nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom":"Unverarbeitete Pflanzen und Pflanzenerzeugnisse, einschließlich Saatgut und anderes Pflanzenvermehrungsmaterial",
                  "Živina in nepredelani proizvodi iz živine":"Tiere und unverarbeitete tierische Erzeugnisse",
                  "Alge in nepredelani proizvodi iz akvakulture:":"Algen und unverarbeitete Aquakulturerzeugnisse",
                  "Predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano":"Verarbeitete landwirtschaftliche Erzeugnisse, einschließlich Aquakulturerzeugnisse, die zur Verwendung als Lebensmittel bestimmt sind",
                  "Krma":"Futtermittel",
                  "Vino":"Wein",
                  "Ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije":"Andere in Anhang I der Verordnung (EU) 2018/848 aufgeführte Erzeugnisse oder nicht durch die vorstehenden Kategorien erfasste Erzeugnisse",



                  "Ekološko kmetijstvo":"Ökologische Produktion",
                  "Ekološki":"Ökologisch/biologisch",
                  "Iz preusmeritve":"in Umstellung",
                  
                  "Pridelava":"Produktion",
                  "Priprava":"Aufbereitung",
                  "Distribucija / Dajanje v promet":"Vertrieb/Inverkehrbringen",
                  "Skladiščenje":"Lagerung",
                  "Uvoz":"Einfuhr",
                  "Izvoz":"Ausfuhr",

                  "Seznam proizvodov":"Verzeichnis der Erzeugnisse",
                  "Ime proizvoda in/ali oznaka kombinirane nomenklature (KN) iz Uredbe Sveta (EGS) št. 2658/87 za proizvode s področja uporabe Uredbe (EU) 2018/848":"Name des Erzeugnisses und/oder Code-Nummer der Kombinierten Nomenklatur (KN-Code) gemäß der Verordnung (EWG) Nr. 2658/87 des Rates (1) für Erzeugnisse im Geltungsbereich der Verordnung (EU) 2018/848",
                  "Status":"Status",
                  "Seznam dejavnosti":"Verzeichnis der Tätigkeiten:",
                  "Opis dejavnosti iz točke 5 dela I v skladu z Uredbo (EU) 2018/848":"Beschreibung der Tätigkeit(en) gemäß Teil I Feld 5 gemäß der Verordnung (EU) 2018/848",
                  "Izvajanje dejavnosti kot podizvajalec za drugega izvajalca dejavnosti, medtem ko podizvajalec ostaja odgovoren za dejavnost oziroma dejavnosti, ki se izvajajo":"Ausübung der Tätigkeit(en) als Subunternehmer für einen anderen Unternehmer, wobei der Subunternehmer für die ausgeübte(n) Tätigkeit(en) verantwortlich bleibt",
                  "Druge informacije":"Weitere Angaben",
                  "Ta dokument zamenjuje dokument s številko":"Dieses Dokument ersetzt das Dokument mit der Nummer",
                  "Ta dokument je bil izdan v skladu z Uredbo (EU) 2018/848 kot potrdilo, da izvajalec dejavnosti izpolnjuje zahteve iz navedene uredbe.":"Dieses Dokument wurde gemäß der Verordnung (EU) 2018/848 ausgestellt, um zu bestätigen, dass der Unternehmer oder die Unternehmergruppe (Nichtzutreffendes streichen) die Anforderungen dieser Verordnung erfüllt.",
                  "Datum/kraj:":"Datum/Ort:",
                  "Direktor:":"Direktor:",
                  "Certifikat je veljaven od":"Zertifikat gültig vom",
                  "do":"bis zum",
                  "telefon":"telefon"

            };

        if(!translation[lang])
              return value;

        return translation[lang][value]?translation[lang][value]:value;


        }   
               
    

      },
    created()
  {

    console.log("Page refresh, checking properties");
        console.log(this.certifikatid);
      
      this.vrniPoId({id:this.certifikatid}).then(()=>{
         var stcertifikata=this.certifikat.stcertifikata;
        console.log(this.gridData);
  
     

  });

  },
  mounted(){
   
 }
}
</script>
<style scoped>

.certifikat.ovoj{
margin:0,auto,0,auto
}
.seznam table
{
  border-collapse: collapse;
}
.seznam .status{

    font-weight:bold;
    font-size:1.0em;
     color:var(--accent);
}
.seznam td {
  border: 1px solid var(--accent);
 
  padding: 15px;
  text-align: left;

}
.naslov.certifikat{
    display:flex;
    align-items:center;
    flex-direction:column;
     font-size:1.4em;
    text-decoration:none;
    margin-bottom:3em;
}
.vrstica{
    display:flex;
    flex-direction:row;
    justify-content:space-between;
}
.naslov{
    font-size:0.8em;
    text-decoration:underline;
}

.sekcija {
     margin-bottom: 2em;
}

.naziv-nosilca,.naslov-nosilca{
    color:var(--accent);
    font-size:1.2em;
    font-weight:bold;

}

.levi-logo{
  flex-grow:1;
  height:100%;
}

.desni-logo{
  flex-grow:1;
  height:100%;
}
.levi-logo img, .desni-logo img{
  height:8em;
  witdh:auto;
}


.certifikat.ovoj{
        
        width: 21cm;
        height: 29.7cm;
            margin:auto !important;
        /* change the margins as you want them to be. */
   } 
.certifikat.glava{
justify-content:space-between;

}


.seznam-proizvodov thead td:nth-child(2){
  w-idth:100px;
}
.noga .sekcija{
  margin-bottom:0;
}
.seznam table
{
  border-collapse: collapse;
  width:100%;
}

.naslov {
  margin-bottom:1em;
}
 

.seznam tbody td.kategorija-naziv{
  background-color: var(--accent);
  color:white;
  font-weight:bold;
  
}

.seznam thead td, td.kategorija-naziv {
  border-top: 1px solid var(--accent);
  border-right: 1px solid var(--accent);
  
}
.seznam td:nth-child(2) {

border-right: 1px solid var(--accent);
}
.seznam td {
  -border: 1px solid var(--accent);
  border-left: 1px solid var(--accent);
  border-bottom: 1px solid var(--accent);
  padding: 0.5em;
  text-align: left;
   border-collapse: collapse;
  

}
.certifikat.ovoj h3{
  font-size:2em;
}


.no-wrap{
  white-space: nowrap;
}

.certifikat.ovoj{

 font-size:3mm;
color: #111;
font-family: "Republika", arial, helvetica, sans-serif;
}

.glava.mali-ovoj {
display:flex;
flex-direction:row;
justify-content: flex-end;
}

.desni-logo{

   
}
.levi-logo{

   
}


.glava.certifikat{
 

    display:flex;
    align-items:center;
    flex-direction:column;
    font-size:1em;
    text-decoration:none;
    justify-content:center;
    flex-grow:1;
    margin-bottom:2em;
    margin-top:2em;
    
}
.glava.certifikat h1{
  font-size:9mm;
  margin:0;
  letter-spacing: 4mm;
  line-height:6mm;
 
  }
 
.vrstica{
    display: grid;
 grid-auto-flow: column;
 grid-auto-columns: 1fr;
  
  margin-bottom :1em;
}
.vrstica>div,.seznam-informacij .vsebina-kategorije {
  border: 1px solid var(--accent);
  padding:0.5em;
}
.vrstica>div:nth-child(1) {
  border-right: none;
  
}
.naslov{
    
    text-decoration:underline;
}

.sekcija {
     margin-bottom: 5mm;
   

}

.naziv-nosilca,.naslov-nosilca,
.naziv-izvajalca,.naslov-izvajalca,.sifra-izvajalca
,.stevilka-certifikata>.stevilka-certifikata,.dejavnosti-izvajalca li{
    color:var(--accent);
    font-size:1.2em;
    font-weight:bold;

}

.seznam tbody td {
    color:var(--accent);
    font-weight:bold;
  }


.certifikat.ovoj{
        /* change the margins as you want them to be. */

   } 


</style>
